import { CloseOutlined, DownloadOutlined, EditOutlined, SaveOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Form, FormInstance, Input, message, Select, Tooltip } from 'antd';
import { PageLoader } from 'components/page-loader/page-loader';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { TransectionApiServices } from '../api/transection-api.service';
import { useUpdateParticipant } from '../use-cases/update-participate';

interface DetailFieldProps {
    label: string;
    value: string | string[];
    editing: boolean;
    customer_id: any;
    form: FormInstance<any>;   // <-- ADD THIS
}
const DetailPage = () => {
    const { id, name } = useParams();
    const formName = 'add-organizer-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm();
    const [editing, setEditing] = useState<boolean>(false);
    const { isLoading, mutate } = useUpdateParticipant();
    const [originalValues, setOriginalValues] = useState<any>(null);
    const [participateDetails, setparticipateDetails] = useState({
        participant_addition_details: []
    } as any)

    const { Option } = Select
    // const handleUpdate = (formData: any) => {
    //     delete formData.photo_price;
    //     delete formData.refund_protect_price;
    //     delete formData.reference_no;
    //     delete formData.auth_id;
    //     delete formData.transaction_id;
    //     delete formData.ticket_category_price;
    //     delete formData.tshirt_price;
    //     const participantData = Object.keys(formData)
    //         .filter(key => key.includes('-'))   
    //         .map(key => {
    //             const customerId = key.split('-')[1];

    //             return {
    //                 id: customerId,
    //                 value: formData[key]
    //             };
    //         })
    //         .filter(item => item.value !== undefined && item.value !== null && item.value !== "");
    //     Object.keys(formData)
    //         .filter(key => key.includes('-'))
    //         .forEach(key => delete formData[key]);
    //     const data: any = {
    //         id: id,
    //         first_name: formData.first_name,
    //         last_name: formData.last_name,
    //         email_address: formData.email_address,
    //         phone_no: formData.phone_no,
    //         participant_data: JSON.stringify(participantData)
    //     };

    //     mutate(data as any, { onSuccess: handleEditClose });
    // };
    const handleUpdate = (formData: any) => {
        [
            "photo_price",
            "refund_protect_price",
            "reference_no",
            "auth_id",
            "transaction_id",
            "ticket_category_price",
            "tshirt_price",
        ].forEach(key => delete formData[key]);

        const participantData = Object.keys(formData)
            .filter(key => key.includes('-'))
            .map(key => {
                const lastDashIndex = key.lastIndexOf('-');
                const customerId = key.substring(lastDashIndex + 1);

                return {
                    id: customerId,
                    value: formData[key]
                };
            })
            .filter(item => item.value !== undefined && item.value !== null && item.value !== "");
        Object.keys(formData)
            .filter(key => key.includes('-'))
            .forEach(key => delete formData[key]);

        const data: any = {
            id: id,
            first_name: formData.first_name,
            last_name: formData.last_name,
            email_address: formData.email_address,
            phone_no: formData.phone_no,
            participant_data: JSON.stringify(participantData)
        };
        mutate(data as any, { onSuccess: handleEditClose });
    };


    const handleEditClose = () => {
        setEditing(false);
    }

    const [tabLoading, setTabLoading] = useState(false)

    const initialparticipant = async () => {
        setTabLoading(true);
        try {
            const apiRes = await TransectionApiServices().getParticiPantdetails(`participant_id=${id}&category=${name}`)
            setparticipateDetails(apiRes)
            setOriginalValues(apiRes);     // 🔥 Backup
            setTabLoading(false)
            form.setFieldsValue(apiRes)
        } catch (error) {
            message.error("This is wrong")
        }
    }
    useEffect(() => {
        initialparticipant()
    }, [name])

    return (

        <>
            {tabLoading ?
                <PageLoader />
                :


                <div>
                    <Form
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        // initialValues={getInitialValues}
                        onFinish={handleUpdate}
                        onFinishFailed={() => setValidateTrigger(['onChange'])}
                        validateTrigger={validateTrigger}
                    >
                        <div className='parti_dtls'>
                            <div className='hed_ttl'>
                                <Breadcrumb separator="/" className='page_brdcrumb'>
                                    <Breadcrumb.Item className='text-decoration-none'><a href='/transactions/participate-List'>Participate List</a></Breadcrumb.Item>
                                    <Breadcrumb.Item className='text-decoration-none'>Details</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <FormSectionsSeparator title="">
                                <div className='button-group'>
                                    {/* {editing ? (
                                        <>
                                            <Button onClick={() => { setEditing(false); form.setFieldsValue(originalValues); initialparticipant() }} style={{ marginRight: '10px' }}><CloseOutlined /> Cancel</Button>
                                            <Button loading={isLoading} htmlType='submit' className='btn' type='primary'><SaveOutlined /> Save</Button>
                                        </>
                                    ) : (
                                        
                                        <Button onClick={() => setEditing(true)} type='primary'><EditOutlined /> Edit </Button>
                                    )} */}
                                    {editing ? (
                                        <>
                                            <Button
                                                onClick={() => {
                                                    setEditing(false);
                                                    form.setFieldsValue(originalValues);
                                                    initialparticipant();
                                                }}
                                                style={{ marginRight: '10px' }}
                                            >
                                                <CloseOutlined /> Cancel
                                            </Button>

                                            <Button
                                                loading={isLoading}
                                                htmlType="submit"
                                                className="btn"
                                                type="primary"
                                            >
                                                <SaveOutlined /> Save
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            {["CAPTURED", "Paid", "Success"].includes(participateDetails?.payment_status) && (
                                                <Button onClick={() => setEditing(true)} type="primary">
                                                    <EditOutlined /> Edit
                                                </Button>
                                            )}
                                        </>
                                    )}

                                </div>
                            </FormSectionsSeparator>
                        </div>

                        <div className='partic_wrapp invoice_list'>
                            <Form.Item
                                name="event_name"
                                label="Event Name"
                                rules={[{ required: true, message: 'Please Enter your Event Name!' }]}
                            >
                                <Input disabled placeholder="Please Enter Event Name" />
                            </Form.Item>
                            <Form.Item
                                name="first_name"
                                label="First Name"
                                rules={[{ required: true, message: 'Please Enter your First Name!' }]}
                            >
                                <Input disabled={editing === false} placeholder="Please Enter your First Name" />
                            </Form.Item>
                            <Form.Item
                                name="last_name"
                                label="Last Name"
                                rules={[{ required: true, message: 'Please Enter your Last Name!' }]}
                            >
                                <Input disabled={editing === false} placeholder="Please Enter your Last Name" />
                            </Form.Item>
                            <Form.Item
                                name="email_address"
                                label="Email Address"
                                rules={[{ required: true, message: 'Please Enter your Email Address' }]}
                            >
                                <Input disabled={editing === false} placeholder="Please Enter your Email" />
                            </Form.Item>
                            <Form.Item
                                name="phone_no"
                                label="Phone No"
                                rules={[{ required: true, message: 'Please Enter your Phone No!' }]}
                            >
                                <Input disabled={editing === false} placeholder="Please Enter your Phone No" />
                            </Form.Item>
                            {/* <Form.Item
                        name="is_keep_refunded"
                        label="Refund Protected"
                        rules={[{ required: true, message: 'Please input your Phone No!' }]}
                    >
                        <Radio.Group >
                            <Radio value={true}>Yes</Radio>
                            <Radio value={false}>No</Radio>
                        </Radio.Group>
                    </Form.Item> */}
                            <Form.Item
                                name="is_keep_refunded"
                                label="Refund Protected"
                                rules={[{ required: true, message: 'Please select an option!' }]}
                            >
                                <Select placeholder="Select an option"
                                    disabled
                                >
                                    <Option value={true}>Yes</Option>
                                    <Option value={false}>No</Option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name="refund_protect_price"
                                label="Refund Protect (in KD)"
                            >
                                <Input disabled placeholder='Enter Refund Protected Price' />
                            </Form.Item>

                            <Form.Item
                                name="medal_price"
                                label="Medal Price"
                                rules={[{ required: true, message: 'Please enter your Medal Price!' }]}
                            >
                                <Input disabled placeholder='Please enter Medal Price' />
                            </Form.Item>

                            <Form.Item
                                name="delivery_option"
                                label="Delivery Type"
                            >
                                <Input disabled />
                            </Form.Item>
                            <Form.Item
                                name="delivery_address"
                                label="Delivery Address"
                            >
                                <Input disabled />
                            </Form.Item>
                            <Form.Item
                                name="delivery_price"
                                label="Delivery Price"
                                rules={[{ required: true, message: 'Please enter your Delivery Price!' }]}
                            >
                                <Input disabled placeholder='Please enter your Delivery Price' />
                            </Form.Item>
                            <Form.Item
                                name="currency_name"
                                label="Currency Name"
                            >
                                <Input disabled placeholder='Please enter Currency Name' />
                            </Form.Item>
                            <Form.Item
                                name="payment_method"
                                label="Payment method"
                            >
                                <Input disabled placeholder="Please enter Payment method" />
                            </Form.Item>
                            <Form.Item
                                name="payment_status"
                                label="Payment Status"
                            >
                                <Input disabled placeholder="Please enter Payment Status" />
                            </Form.Item>
                            <Form.Item
                                name="photo_price"
                                label="Photo Price"
                                rules={[{ required: true, message: 'Please enter Photo Price!' }]}
                            >
                                <Input disabled placeholder="Please enter Photo Price" />
                            </Form.Item>

                            <Form.Item
                                name="ticket_category_name"
                                label="Ticket Name"
                            >
                                <Input disabled placeholder="Please enter Ticket name" />
                            </Form.Item>

                            <Form.Item
                                name={name === "Layout" ? "total_price" : "ticket_category_price"}
                                label="Ticket Price"
                                rules={[{ required: true, message: 'Please enter Ticket  Price' }]}
                            >
                                <Input disabled placeholder="Ticket Price" />
                            </Form.Item>
                            <Form.Item
                                name="tshirt_price"
                                label="Tshirt Price"
                                rules={[{ required: true, message: 'Please enter T-shirt Price' }]}
                            >
                                <Input disabled placeholder="tshirt_price" />
                            </Form.Item>
                            <Form.Item
                                name="transaction_id"
                                label="Transaction Id"
                            >
                                <Input disabled placeholder="Please enter Transaction Id" />
                            </Form.Item>
                            <Form.Item
                                name="auth_id"
                                label="Auth Id"
                            >
                                <Input disabled placeholder="Please enter AuthId" />
                            </Form.Item>
                            <Form.Item
                                name="reference_no"
                                label="Reference No"
                            >
                                <Input disabled placeholder="Please enter Reference No" />
                            </Form.Item>

                            <Form.Item
                                name="SeatNumbers"
                                label="Seat Number"
                            >
                                <Input disabled placeholder="Please enter Seat No" />
                            </Form.Item>

                        </div>
                        <div className='prti_form'>
                            <FormSectionsSeparator title="">
                                {participateDetails?.participant_addition_details?.map((res: any, index: number) => {
                                    return (
                                        <DetailField key={index} label={res.key_lable} value={res?.key_value} editing={editing} customer_id={res.customer_id} form={form} />
                                    )
                                })}
                            </FormSectionsSeparator>
                        </div>
                    </Form>
                </div>}
        </>

    );
};

const handleDownloadImg = (img: any) => {
    if (!img) return;
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    const form = document.createElement('form');
    form.method = 'GET';
    form.action = img;

    iframe.appendChild(form);
    form.submit();

    iframe.onload = () => {
        document.body.removeChild(iframe);
        message.success('Image downloaded');
    };

}

// const DetailField: React.FC<DetailFieldProps> = ({ label, value, customer_id, editing }) => (
//     <Form.Item className='w-100' label={
//         <Tooltip title={label} className=''>
//             <span className='truncate-label'>{label} </span>
//             <span className='dwnld_icon'>{
//                 value.includes("https://suffixevnt.blob.core.windows.net/events/CustomerEventRegistrationForm/image") &&
//                 <DownloadOutlined onClick={() => handleDownloadImg(value)} />}</span>
//         </Tooltip>
//     } name={`${label}-${customer_id}`} >
//         <Input defaultValue={value} disabled={editing === false} />
//     </Form.Item>
// );
const DetailField: React.FC<DetailFieldProps> = ({
    label,
    value,
    customer_id,
    editing,
    form,
}: any) => {

    const fieldName = `${label}-${customer_id}`;
    const isTicketField = label.trim().toLowerCase() === "how many tickets?";
    useEffect(() => {
        // Set initial value each time value changes (like on Cancel)
        form.setFieldsValue({ [fieldName]: value });
    }, [value, fieldName]);

    return (
        <Form.Item
            className="w-100"
            label={
                <Tooltip title={label}>
                    {/* <span className="truncate-label">{label}</span> */}
                    <span className="truncate-label">
                        {String(label || "").length > 40 ? String(label).substring(0, 70) + "..." : label}
                    </span>
                    <span className="dwnld_icon">
                        {value?.includes("https://suffixevnt.blob.core.windows.net/events/CustomerEventRegistrationForm/image") && (
                            <DownloadOutlined onClick={() => handleDownloadImg(value)} />
                        )}
                    </span>
                </Tooltip>
            }
            name={fieldName}
            rules={[
                { required: true, message: `${label} is required` },
                // ✅ Custom validation for spaces
                {
                    validator: (_, val) => {
                        if (!val) return Promise.resolve();

                        if (val.trim() !== val)
                            return Promise.reject("No leading or trailing spaces allowed.");

                        if (/\s{2,}/.test(val))
                            return Promise.reject("Multiple spaces are not allowed.");

                        return Promise.resolve();
                    }
                }
            ]}
        >
            <Input disabled={isTicketField ? true : !editing} />
        </Form.Item>
    );
};



export default DetailPage;
